import { Button } from "@/components/ui/button";
import { useRef, useEffect, useState } from "react";
import Modal from "@/components/Modal";
import CreatorLeadForm from "@/components/CreatorLeadForm";
import BusinessLeadForm from "@/components/BusinessLeadForm";
import img from "../../public/lovable-uploads/0b3c3dab-7f08-4fa2-9306-06615336a55a.png";
import img2 from "../../public/lovable-uploads/pexels-giuseppe-di-maria-163888120-14435282_1749705310244.jpg";
import HTML_Renderer from "./HTML_Renderer";
export default function SplitSection({ content }) {
  const [scrollY, setScrollY] = useState(0);
  const [creatorModalOpen, setCreatorModalOpen] = useState(false);
  const [businessModalOpen, setBusinessModalOpen] = useState(false);
  const creatorsRef = useRef<HTMLDivElement>(null);
  const businessesRef = useRef<HTMLDivElement>(null);
  const creatorsContentRef = useRef<HTMLDivElement>(null);
  const businessesContentRef = useRef<HTMLDivElement>(null);

  // Handle scroll position
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Apply scroll-based animations
  useEffect(() => {
    if (!creatorsRef.current || !businessesRef.current) return;

    const applyParallaxEffect = (
      element: HTMLElement,
      contentElement: HTMLElement | null,
      sectionTop: number,
      intensity = 0.2
    ) => {
      const rect = element.getBoundingClientRect();
      const sectionScrolled = scrollY - sectionTop + window.innerHeight;
      const progress = Math.max(
        0,
        Math.min(1, sectionScrolled / (rect.height + window.innerHeight))
      );

      // Parallax effect for content
      if (contentElement) {
        contentElement.style.transform = `translateY(${
          progress * 50 * intensity
        }px)`;
      }

      // Opacity effect based on scroll position
      element.style.opacity = Math.min(1, progress * 1.5).toString();
    };

    const creatorsTop = creatorsRef.current ? creatorsRef.current.offsetTop : 0;
    const businessesTop = businessesRef.current
      ? businessesRef.current.offsetTop
      : 0;

    applyParallaxEffect(
      creatorsRef.current,
      creatorsContentRef.current,
      creatorsTop
    );
    applyParallaxEffect(
      businessesRef.current,
      businessesContentRef.current,
      businessesTop
    );
  }, [scrollY]);

  return (
    <>
      {/* Creators Section - Dark Background */}
      <section className="creators-section bg-musicBlack relative overflow-hidden py-20">
        <div className="editorial-container relative z-10">
          <div
            ref={creatorsRef}
            className="flex flex-col md:flex-row items-center justify-between gap-12 transition-all duration-500"
          >
            <div
              ref={creatorsContentRef}
              className="md:w-1/2 text-white transition-all duration-700"
            >
              <h2 className="editorial-heading mb-3">
                {content.creators_features.title}
              </h2>
              

              <HTML_Renderer className={'mb-8'} content={content.creators_features.content} />

              {/*
              <h3 className="editorial-subheading gradient-text-red mb-4">
                Your Music. Your Rights. Your Royalties.
              </h3>
              <p className="editorial-body mb-6 text-musicGrey/90">
                Music Nation empowers songwriters, composers, publishers, sound
                recording owners and featured artists with tools to register,
                protect, and receive compensation for their creative work across
                the UAE.
              </p>
              <ul className="space-y-4 mb-8 text-sm">
                <li>✓ Register and Protect your work</li>
                <li>✓ Receive royalties for the public use of your work</li>
                <li>✓ Track your works usage</li>
              </ul>*/}
              <Button
                className="cta-button relative hover:scale-105 transition-transform duration-300"
                onClick={() => setCreatorModalOpen(true)}
              >
                Learn More
              </Button>
            </div>
            <div className="md:w-1/2 transition-all duration-700">
              <img
                src={content.creators_features.banner || img2}
                alt="creator"
                className="rounded-xl shadow-lg w-full object-cover transform transition-all duration-700 hover:scale-[1.02]"
              />
            </div>
          </div>
        </div>

        {/* Angular divider for creators section */}
        <div className="absolute bottom-0 left-0 right-0 w-full h-16 overflow-hidden">
          <svg
            viewBox="0 0 1200 60"
            preserveAspectRatio="none"
            className="w-full h-full"
            xmlns="http://www.w3.org/2000/svg"
            fill="#222222"
          >
            <polygon points="0,60 1200,60 1200,0 600,60 0,0" />
          </svg>
        </div>
      </section>

      {/* Businesses Section - Light Background */}
      <section className="businesses-section bg-musicLight relative overflow-hidden py-20">
        <div className="editorial-container relative z-10">
          <div
            ref={businessesRef}
            className="flex flex-col-reverse md:flex-row items-center justify-between gap-12 transition-all duration-500"
          >
            <div className="md:w-1/2 transition-all duration-700">
              <img
                src={content.businesses_features.banner || img}
                alt="business"
                className="rounded-xl shadow-lg w-full object-cover transform transition-all duration-700 hover:scale-[1.02]"
              />
            </div>
            <div
              ref={businessesContentRef}
              className="md:w-1/2 text-musicBlack transition-all duration-700"
            >
              <h2 className="editorial-heading mb-3">
                {content.businesses_features.title}
              </h2>

              <HTML_Renderer className={'mb-8'} content={content.businesses_features.content} />

              {/*<h3 className="editorial-subheading gradient-text-red mb-4">
                Use Music Legally. Protect Your Business.
              </h3>
              <p className="editorial-body mb-6">
                Comply with UAE regulations while enhancing your customer
                experience with properly licensed music for your business.
              </p>
              <ul className="space-y-4 mb-8 text-sm">
                <li>✓ Understand licensing requirements</li>
                <li>✓ Automatically calculate and pay your license fees</li>
                <li>✓ Avoid legal copyright infringement issues</li>
              </ul>*/}
              <Button
                className="cta-button relative hover:scale-105 transition-transform duration-300"
                onClick={() => setBusinessModalOpen(true)}
              >
                Register your Business
              </Button>
            </div>
          </div>
        </div>

        {/* Angular divider for businesses section */}
        <div className="absolute bottom-0 left-0 right-0 w-full h-16 overflow-hidden">
          <svg
            viewBox="0 0 1200 60"
            preserveAspectRatio="none"
            className="w-full h-full"
            xmlns="http://www.w3.org/2000/svg"
            fill="#F5F5F5"
          >
            <polygon points="0,60 1200,60 1200,0 600,60 0,0" />
          </svg>
        </div>
      </section>

      {/* Creator Modal */}
      <Modal open={creatorModalOpen} onClose={() => setCreatorModalOpen(false)}>
        <CreatorLeadForm onClose={() => setCreatorModalOpen(false)} />
      </Modal>

      {/* Business Modal */}
      <Modal
        open={businessModalOpen}
        onClose={() => setBusinessModalOpen(false)}
      >
        <BusinessLeadForm onClose={() => setBusinessModalOpen(false)} />
      </Modal>
    </>
  );
}
